import i18n from 'i18next'
import LanguageDetector from 'i18next-browser-languagedetector'
import { reactI18nextModule } from 'react-i18next'
import en from './langs/en'
import ru from './langs/ru'
import bg from './langs/bg'
import ch from './langs/ch'
import cz from './langs/cz'
import ind from './langs/in'
import ko from './langs/ko'
import my from './langs/my'
import pl from './langs/pl'
import th from './langs/th'
import zh_hk from './langs/zh-hk'
import zh_tw from './langs/zh-tw'
import vi from './langs/vn'
import ja from './langs/jp'
import {getIsRuServer} from './getIsRuServer'

const previouslySavedLanguage = localStorage.getItem('i18nextLng')
const serverDefaultLanguage = getIsRuServer() ? 'RU_RU' :'EN_EN'

i18n
  .use(LanguageDetector)
  .use(reactI18nextModule)
  .init({
    lng: previouslySavedLanguage || serverDefaultLanguage,
    fallbackLng: getIsRuServer() ? 'RU_RU' :'EN_EN',
    debug: true,
    react: {
      wait: true,
      bindI18n: 'languageChanged'
    },
    resources: {
      EN_EN: en,
      RU_RU: ru,
      BG_BG: bg,
      CH: ch,
      CZ_CZ: cz,
      IN: ind,
      KO: ko,
      MY: my,
      PL_PL: pl,
      TH: th,
      ZH_HK: zh_hk,
      ZH_TW: zh_tw,
      VI: vi,
      JA: ja
    }
  })

export default i18n
